import PropTypes from 'prop-types';
import { Edit, useNotify, usePermissions, useRefresh, useTranslate } from 'react-admin';
import { RightDrawer } from '@/components/global/drawers/RightDrawer';
import { BrandForm } from '@/components/brand/forms/BrandCreate.jsx';
import { toBrandFormValues, transformBrandPayload } from '@/components/brand/validators/brandValidators.js';

export const BrandEdit = ({ handleClose = () => {}, elementId }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    const { permissions } = usePermissions();

    if (!permissions?.isAdmin) {
        return null;
    }

    return (
        <RightDrawer handleClose={handleClose} title={translate('resources.brand.labels.edit')}>
            <Edit
                resource='brand'
                mutationMode='pessimistic'
                id={elementId}
                actions={false}
                transform={transformBrandPayload}
                queryOptions={{
                    select: toBrandFormValues,
                }}
                mutationOptions={{
                    onSuccess: () => {
                        notify(translate('resources.brand.notifications.updated'));
                        refresh();
                        handleClose();
                    },
                }}
                redirect={false}
            >
                <BrandForm handleClose={handleClose} />
            </Edit>
        </RightDrawer>
    );
};

BrandEdit.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
